import { MemberLevel, MemberStatus } from './enums'
import { WORKSPACE_NOTIFICATION_CHANNEL } from './settings.const'
import type { WorkspaceMember, WorkspaceNotificationGroup, WorkspaceSettings } from './settings.interface'

export const WORKSPACE_MOCK: WorkspaceSettings = {
  id: 'workspace-1',
  name: 'SDN Center',
  logo: null,
  dataResidencyRegion: 'Europe',
  createdAt: '2026-03-23T12:00:00Z',
  projectCount: 4,
  memberCount: 16,
}

export const WORKSPACE_MEMBERS_MOCK: WorkspaceMember[] = [
  {
    id: 'member-1',
    name: 'John Doe',
    email: 'john.doe@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.ADMIN,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-20T10:30:00.000Z',
    projectIds: ['project-1', 'project-2', 'project-3'],
  },
  {
    id: 'member-2',
    name: 'Alice Martin',
    email: 'alice.martin@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.DEVELOPER,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-20T08:15:00.000Z',
    projectIds: ['project-1', 'project-2'],
  },
  {
    id: 'member-3',
    name: 'Bob Smith',
    email: 'bob.smith@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.DEVELOPER,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-19T14:00:00.000Z',
    projectIds: ['project-1'],
  },
  {
    id: 'member-4',
    name: 'Clara Johnson',
    email: 'clara.johnson@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.ADMIN,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-18T16:45:00.000Z',
    projectIds: ['project-1', 'project-2', 'project-3', 'project-4'],
  },
  {
    id: 'member-5',
    name: null,
    email: 'new.member@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.DEVELOPER,
    status: MemberStatus.PENDING,
    lastSeen: null,
    projectIds: [],
  },
  {
    id: 'member-6',
    name: 'David Lee',
    email: 'david.lee@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.DEVELOPER,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-17T09:30:00.000Z',
    projectIds: ['project-2'],
  },
]

export const WORKSPACE_NOTIFICATIONS_MOCK: WorkspaceNotificationGroup[] = [
  {
    id: 'GRAFTS',
    items: [
      {
        id: 'CREATED',
        groupId: 'GRAFTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'FAILED',
        groupId: 'GRAFTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'UPDATED',
        groupId: 'GRAFTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'GATEWAYS_SERVICES',
    items: [
      {
        id: 'CONFIG_CHANGED',
        groupId: 'GATEWAYS_SERVICES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'CONNECTED',
        groupId: 'GATEWAYS_SERVICES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'LATENCY',
        groupId: 'GATEWAYS_SERVICES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'PACKAGES',
    items: [
      {
        id: 'INSTALLED',
        groupId: 'PACKAGES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'UPDATE',
        groupId: 'PACKAGES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'INSECURE',
        groupId: 'PACKAGES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'DIGESTS',
    items: [
      {
        id: 'DAILY',
        groupId: 'DIGESTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'WEEKLY',
        groupId: 'DIGESTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'VULNERABILITIES',
    items: [
      {
        id: 'WARNINGS',
        groupId: 'VULNERABILITIES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'CRITICAL',
        groupId: 'VULNERABILITIES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'SYSTEM_ADMIN',
    items: [
      {
        id: 'PERMISSIONS',
        groupId: 'SYSTEM_ADMIN',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'BILLING',
        groupId: 'SYSTEM_ADMIN',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
]
